import { CustomCreateProposalMutationVariables, ProposalSource } from "generated/graphql";
import { z } from "zod";

const CONFIDENCE_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100] as const;

export const createProposalSchema = z.object({
  companyId: z.string().min(1, "Please select a company"),
  contactId: z.string().min(1, "Please select a contact"),
  source: z.nativeEnum(ProposalSource).optional(),
  projectedCloseDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date")
    .nullable()
    .optional(),
  closeConfidence: z
    .number()
    .int("Confidence must be a whole number")
    .refine((v) => CONFIDENCE_OPTIONS.includes(v as any), "Confidence must be 10–100 in 10% steps")
    .nullable()
    .optional(),
});

export const getDefaultValues = (
  initialValues: Partial<CustomCreateProposalMutationVariables>
): Partial<CustomCreateProposalMutationVariables> => ({
  companyId: "",
  contactId: "",
  source: undefined,
  projectedCloseDate: null,
  closeConfidence: null,
  ...initialValues,
});
